import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import getters from './getters'
// import mutations from './mutations'
// import actions from './actions'

// modules
import task from './modules/task'
import search from './modules/search'


// require('es6-promise').polyfill();


export default new Vuex.Store({
    state:{
        userInfo:{},    //登录用户的个人信息
        buInfo:{},       //登录用户的bu信息
        taskTpl:[],  //任务类型 列表
        currencyList:[],  //快币类型 列表
        personalTicket:[],  //个人罚单列表
        allPost:[],   //公司配置的岗位列表
        allBonusCycle:[],  //所有奖金周期信息
        screenFullFlag:false,  //全屏遮罩
        bu_users:[],  // bu成员
        bu_list:[],  // 可选择 bu 列表

        picker_special: {   //特殊日期
            shortcuts: [{
                text: '今天',
                onClick(picker) {
                    let today = new Date()
                    today.setHours(0);
                    today.setMinutes(0);
                    today.setSeconds(0);
                    today.setMilliseconds(0);
                    picker.$emit('pick', today);
                }
            }]
        },
        apply:{  //审核申请 用的公用数据
            statusObj:{
                1:"待处理",
                2:"审核成功",
                3:"审核失败",
                5:"已处理",
            },
            statusOption:[
                {id:"1",label:"待处理"},
                {id:"5",label:"已处理"},
            ],
            postType:{
                1:"内部转岗",
                2:"社会招聘",
            }
        },
        cycle_interval:[  //周期间隔 option
            {
                val:10,
                text:"1个月"
            },   
            {
                val:20,
                text:"3个月"
            },   
            {
                val:30,
                text:"半年"
            },   
            {
                val:40,
                text:"年"
            },   
        ],
    },
    getters,
    // mutations,
    // actions,
    modules:{
        task,
        search,
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js